import { ErrorHandler, Injectable } from '@angular/core';
import { NotificationService } from '../../service/notification.service';
import { NotificationType } from '../../shared/enum/notification.enum';
import { LoaderService } from '../loader/loader.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
	constructor(private loaderService: LoaderService, private notificationService: NotificationService) {}

	handleError(error) {
		console.log(error);
		this.loaderService.hide();
		this.notificationService.show('Something went wrong', NotificationType.Error);
	}
}
